export class PromiseTimedOut extends Error {
  constructor(timeoutInMs: number) {
    const message = `Promise timed out after ${timeoutInMs} ms.`;
    super(message);
  }
}

export const promiseWithTimeout = <T = unknown>(promise: Promise<T>, timeoutInMs: number): Promise<T> => {
  if (!timeoutInMs || timeoutInMs <= 0) {
    throw new Error('PromiseWithTimeout: Timeout must be a positive number.');
  }
  const timerPromise = new Promise<never>((_, reject) => {
    const timer = setTimeout(() => {
      clearTimeout(timer);
      reject(new PromiseTimedOut(timeoutInMs));
    }, timeoutInMs);
  });

  return Promise.race([promise, timerPromise]);
};
